import { render, staticRenderFns } from "./CargoView.vue?vue&type=template&id=f83fe1fa&scoped=true"
import script from "./CargoView.vue?vue&type=script&lang=js"
export * from "./CargoView.vue?vue&type=script&lang=js"
import style0 from "./CargoView.vue?vue&type=style&index=0&id=f83fe1fa&prod&scoped=true&lang=css"
import style1 from "./CargoView.vue?vue&type=style&index=1&id=f83fe1fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83fe1fa",
  null
  
)

export default component.exports